/** App Store Connect territory IDs (3-letter) — mirrors api/internal/infrastructure/appstoreconnect/territories.go */
const ASC_TERRITORY_CODES = [
  'AFG', 'AGO', 'AIA', 'ALB', 'ARE', 'ARG', 'ARM', 'ATG', 'AUS', 'AUT',
  'AZE', 'BEL', 'BEN', 'BFA', 'BGR', 'BHR', 'BHS', 'BIH', 'BLR', 'BLZ',
  'BMU', 'BOL', 'BRA', 'BRB', 'BRN', 'BTN', 'BWA', 'CAN', 'CHE', 'CHL',
  'CHN', 'CIV', 'CMR', 'COD', 'COG', 'COL', 'CPV', 'CRI', 'CYM', 'CYP',
  'CZE', 'DEU', 'DMA', 'DNK', 'DOM', 'DZA', 'ECU', 'EGY', 'ESP', 'EST',
  'FIN', 'FJI', 'FRA', 'FSM', 'GAB', 'GBR', 'GEO', 'GHA', 'GMB', 'GNB',
  'GRC', 'GRD', 'GTM', 'GUY', 'HKG', 'HND', 'HRV', 'HUN', 'IDN', 'IND',
  'IRL', 'IRQ', 'ISL', 'ISR', 'ITA', 'JAM', 'JOR', 'JPN', 'KAZ', 'KEN',
  'KGZ', 'KHM', 'KNA', 'KOR', 'KWT', 'LAO', 'LBN', 'LBR', 'LBY', 'LCA',
  'LKA', 'LTU', 'LUX', 'LVA', 'MAC', 'MAR', 'MDA', 'MDG', 'MDV', 'MEX',
  'MKD', 'MLI', 'MLT', 'MMR', 'MNE', 'MNG', 'MOZ', 'MRT', 'MSR', 'MUS',
  'MWI', 'MYS', 'NAM', 'NER', 'NGA', 'NIC', 'NLD', 'NOR', 'NPL', 'NRU',
  'NZL', 'OMN', 'PAK', 'PAN', 'PER', 'PHL', 'PLW', 'PNG', 'POL', 'PRT',
  'PRY', 'QAT', 'ROU', 'RUS', 'RWA', 'SAU', 'SEN', 'SGP', 'SLB', 'SLE',
  'SLV', 'SRB', 'STP', 'SUR', 'SVK', 'SVN', 'SWE', 'SWZ', 'SYC', 'TCA',
  'TCD', 'THA', 'TJK', 'TKM', 'TON', 'TTO', 'TUN', 'TUR', 'TWN', 'TZA',
  'UGA', 'UKR', 'URY', 'USA', 'UZB', 'VCT', 'VEN', 'VGB', 'VNM', 'VUT',
  'YEM', 'ZAF', 'ZMB', 'ZWE',
] as const;

const TERRITORY_LABELS: Record<string, string> = {
  USA: 'United States',
  GBR: 'United Kingdom',
  TUR: 'Türkiye',
  DEU: 'Germany',
  FRA: 'France',
  ESP: 'Spain',
  ITA: 'Italy',
  NLD: 'Netherlands',
  BEL: 'Belgium',
  AUT: 'Austria',
  CHE: 'Switzerland',
  SWE: 'Sweden',
  NOR: 'Norway',
  DNK: 'Denmark',
  FIN: 'Finland',
  POL: 'Poland',
  CZE: 'Czech Republic',
  GRC: 'Greece',
  PRT: 'Portugal',
  IRL: 'Ireland',
  ROU: 'Romania',
  HUN: 'Hungary',
  UKR: 'Ukraine',
  RUS: 'Russia',
  JPN: 'Japan',
  KOR: 'South Korea',
  CHN: 'China mainland',
  HKG: 'Hong Kong',
  TWN: 'Taiwan',
  IND: 'India',
  IDN: 'Indonesia',
  MYS: 'Malaysia',
  SGP: 'Singapore',
  THA: 'Thailand',
  VNM: 'Vietnam',
  PHL: 'Philippines',
  AUS: 'Australia',
  NZL: 'New Zealand',
  CAN: 'Canada',
  MEX: 'Mexico',
  BRA: 'Brazil',
  ARG: 'Argentina',
  COL: 'Colombia',
  CHL: 'Chile',
  PER: 'Peru',
  ZAF: 'South Africa',
  SAU: 'Saudi Arabia',
  ARE: 'United Arab Emirates',
  ISR: 'Israel',
  EGY: 'Egypt',
  NGA: 'Nigeria',
  KEN: 'Kenya',
  // Region price tier (T1-T4) countries not already covered above.
  LUX: 'Luxembourg',
  ISL: 'Iceland',
  QAT: 'Qatar',
  KWT: 'Kuwait',
  BHR: 'Bahrain',
  SVK: 'Slovakia',
  SVN: 'Slovenia',
  EST: 'Estonia',
  LVA: 'Latvia',
  LTU: 'Lithuania',
  HRV: 'Croatia',
  MLT: 'Malta',
  CYP: 'Cyprus',
  URY: 'Uruguay',
  PAN: 'Panama',
  CRI: 'Costa Rica',
  ECU: 'Ecuador',
  DOM: 'Dominican Republic',
  GTM: 'Guatemala',
  BGR: 'Bulgaria',
  SRB: 'Serbia',
  KAZ: 'Kazakhstan',
  PAK: 'Pakistan',
  BGD: 'Bangladesh',
  LKA: 'Sri Lanka',
  NPL: 'Nepal',
  GHA: 'Ghana',
  CIV: "Côte d'Ivoire",
  MAR: 'Morocco',
  DZA: 'Algeria',
  TUN: 'Tunisia',
  SEN: 'Senegal',
  TZA: 'Tanzania',
  UGA: 'Uganda',
  KHM: 'Cambodia',
  MMR: 'Myanmar',
  LAO: 'Laos',
  MNG: 'Mongolia',
  UZB: 'Uzbekistan',
};

export const APP_STORE_TERRITORIES: { value: string; label: string }[] = ASC_TERRITORY_CODES.map(code => ({
  value: code,
  label: TERRITORY_LABELS[code] ? `${code} — ${TERRITORY_LABELS[code]}` : code,
}));

export function getTerritoryLabel(code: string): string {
  const entry = APP_STORE_TERRITORIES.find(t => t.value === code);
  return entry?.label ?? code;
}
